function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { styled, forwardRef } from '@grupoboticario/flora-react-system';
var StyledCard = styled('div', {
  appearance: 'none',
  border: 'none',
  boxSizing: 'border-box',
  font: 'inherit',
  lineHeight: '1',
  outline: 'none',
  textAlign: 'inherit',
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
  backgroundColor: '$backgroundPrimary',
  display: 'block',
  textDecoration: 'none',
  color: 'inherit',
  flexShrink: 0,
  borderRadius: '$medium',
  position: 'relative',
  padding: '$3',
  '&::before': {
    boxSizing: 'border-box',
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    boxShadow: 'inset 0 0 0 1px rgb(180, 180, 180, .3)',
    borderRadius: '$medium',
    pointerEvents: 'none'
  },
  variants: {
    padded: {
      false: {
        padding: 0
      }
    },
    variant: {
      interactive: {
        cursor: 'pointer',
        '@hover': {
          '&:hover': {
            '&::before': {
              boxShadow: 'inset 0 0 0 1px rgb(180, 180, 180, .7)'
            }
          }
        },
        '&:focus': {
          '&::before': {
            boxShadow: 'inset 0 0 0 1px $colors$backgroundAltPrimary, 0 0 0 1px $colors$backgroundAltPrimary'
          }
        }
      },
      ghost: {
        cursor: 'pointer',
        backgroundColor: 'transparent',
        transition: 'transform 200ms cubic-bezier(0.22, 1, 0.36, 1), background-color 25ms linear',
        willChange: 'transform',
        '&::before': {
          boxShadow: '$downFar',
          opacity: '0',
          transition: 'all 200ms cubic-bezier(0.22, 1, 0.36, 1)'
        },
        '@hover': {
          '&:hover': {
            backgroundColor: '$background',
            transform: 'translateY(-2px)',
            '&::before': {
              opacity: '1'
            }
          }
        },
        '&:active': {
          transform: 'translateY(0)',
          transition: 'none',
          '&::before': {
            boxShadow: '$downClose',
            opacity: '1'
          }
        },
        '&:focus': {
          boxShadow: 'inset 0 0 0 1px $colors$backgroundAltPrimary, 0 0 0 1px $colors$backgroundAltPrimary'
        }
      },
      active: {
        cursor: 'pointer',
        transform: 'translateY(0)',
        transition: 'none',
        '&::before': {
          boxShadow: '$downMid',
          opacity: '1'
        },
        '&:focus': {
          boxShadow: 'inset 0 0 0 1px $colors$backgroundAltPrimary, 0 0 0 1px $colors$backgroundAltPrimary'
        }
      }
    }
  }
});

/**
 * @component
 * @name Card
 * @description Card component
 * @tutorial https://flora.gb.tech/docs/components/core/card
 */
export var Card = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledCard, _extends({}, props, {
    "data-flora": "card",
    ref: forwardedRef
  }));
});
//# sourceMappingURL=Card.js.map